import styled from 'styled-components'

import { Typography } from '../typography'

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dbe0eb;
  padding-bottom: 8px;
  margin-bottom: 20px;
`

export const TitleTypography = styled(Typography)`
  color: #232d42;
  font-size: 24px;
  font-weight: 500;
`

export const EditContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`

interface IEditTextProps {
  disabled?: boolean
}

export const EditText = styled(Typography)<IEditTextProps>`
  color: ${({ disabled }) => (disabled ? '#d8dade' : '#6B7280')};
  font-size: 16px;
  font-weight: 600;
`
